import {convertCoordinates} from '@/api/util-coordinates';

class BeachApiResponseModel {
  // #region Props

  // #endregion
  constructor({
    id,
    name,
    description,
    province,
    region,
    cx,
    cy,
    // visible,
    town,
    blueFlag,
    hasWC,
    hasShowers,
    hasFood,
    hasDrinks,
    hasDisabledAccess,
  }) {
    return {
      id,
      name,
      description,
      province,
      region,
      town,
      blueFlag,
      hasWC,
      hasShowers,
      hasFood,
      hasDrinks,
      hasDisabledAccess,
      coordinates: convertCoordinates(cx, cy),
      visible: false, // TODO: Quitar cuando esté en la api
    };
  }
}

export default BeachApiResponseModel;
